/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  constants.ts
 */

export const LOG_LEVEL_NONE_NAME = 'none' as const
export const LOG_LEVEL_NONE = -1 as const
export const LOG_LEVEL_DEBUG_NAME = 'debug' as const
export const LOG_LEVEL_DEBUG = 0 as const
export const LOG_LEVEL_LOG_NAME = 'log' as const
export const LOG_LEVEL_LOG = 1 as const
export const LOG_LEVEL_INFO_NAME = 'info' as const
export const LOG_LEVEL_INFO = 2 as const
export const LOG_LEVEL_WARN_NAME = 'warn' as const
export const LOG_LEVEL_WARN = 3 as const
export const LOG_LEVEL_ERROR_NAME = 'error' as const
export const LOG_LEVEL_ERROR = 4 as const
export const LOG_LEVEL_CRITICAL_NAME = 'critical' as const
export const LOG_LEVEL_CRITICAL = 5 as const
